<app-popin popinTitle="reports.trends"
           [loader]="loading$ | async"
           [removeBodyContainer]="true"
           [closeIcon]="true"
           (onClose)="dialogRef.close()">
  <div subtitle>
    <h2 class="display-flex">
      <app-source [item]="data.colDef.params.metric.payload"></app-source>
      <span class="ml-5">
        {{ dimension$ | async }}
      </span>
    </h2>
  </div>
  <div content>
    <div class="">
      <div echarts
           id="chart-container"
           [options]="chartOption$ | async"></div>
      <div id="table-container"
           class="relative">
        <app-ag-grid class="lh-34"
                     [columnDefs]="columnDefs"
                     [gridOptions]="gridOptions"
                     [suppressContextMenu]="true"
                     [defaultColDef]="defaultColDef"
                     [rowData]="rows$ | async"></app-ag-grid>
      </div>
    </div>
  </div>
</app-popin>
